import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import Tratamientos from "@/pages/Tratamientos";
import Contacto from "@/pages/Contacto";
import Promociones from "@/pages/Promociones";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import TrabajaConNosotros from "@/pages/TrabajaConNosotros";
import { LanguageProvider } from "@/i18n/LanguageContext";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const Layout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tratamientos" element={<Tratamientos />} />
            <Route path="/promociones" element={<Promociones />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/trabaja-con-nosotros" element={<TrabajaConNosotros />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
